<template>
    <div class="popup-shopping-cart-vue">
        <div class="row">
            <div class="col s12">

                <popup_shopping_cart_datatable />

            </div>
        </div>

    </div>
</template>
<script>

import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import axios from 'axios'
import session from 'sessionstorage'

import chunk from 'chunk'




import api from '../../static/api.config.js'

import popup_shopping_cart_datatable from '@/datatables/popup_shopping_cart_datatable.vue'



const vthis = this




export default {
    name: 'shopping_cart',
    components:{
        popup_shopping_cart_datatable
    },
    props: {
    },
    data: function(){
        return{

        }

    },
    async mounted(){



        
    },
    methods: {

    },
    computed: {

        
        
    },
    beforeCreate: function(){


    },
    created: function(){

        
    },
    update(){
    }
}
</script>


// WEBPACK FOOTER //
// src/components/popup_shopping_cart.vue